import { Component } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-dialog-validity',
  templateUrl: './dialog-validity.component.html',
  styleUrl: './dialog-validity.component.scss'
})
export class DialogValidityComponent {
  constructor(
    public dynamicDialogRef: DynamicDialogRef
  ) { }
}